import { Dispatch } from "redux";

const applicationSettings = require("../../translations/applicationSettings.json");

export function loadApplicationSettings() {
  return function (dispatch: Dispatch<any>) {
    var currentUrl = window.location.href;
    if (currentUrl.includes("localhost")) {
      dispatch(
        loadApplicationSettingsSuccess(
          applicationSettings.WebapiUrls.devPlatform,
          applicationSettings.Local.iKey
        )
      );
    } else if (currentUrl.includes("dev")) {
      dispatch(
        loadApplicationSettingsSuccess(
          applicationSettings.WebapiUrls.devPlatform,
          applicationSettings.Dev.iKey
        )
      );
    } else if (currentUrl.includes("uat")) {
      dispatch(
        loadApplicationSettingsSuccess(
          applicationSettings.WebapiUrls.uatPlatform,
          applicationSettings.Uat.iKey
        )
      );
    } else if (currentUrl.includes("test")) {
      dispatch(
        loadApplicationSettingsSuccess(
          applicationSettings.WebapiUrls.testPlatform,
          applicationSettings.Test.iKey
        )
      );
    } else {
      dispatch(
        loadApplicationSettingsSuccess(
          applicationSettings.WebapiUrls.prodPlatform,
          applicationSettings.Prod.iKey
        )
      );
    }
  };
}

export function loadApplicationSettingsSuccess(webapiUrl, iKey) {
  return { type: "application_settings", webapiUrl, iKey: iKey ? iKey : "" };
}



// WEBPACK FOOTER //
// ./src/store/actions/applicationSettingsActions.tsx